export default "/images/regin.svg?c611db77c9281f69955075801e25337e";